import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { HttpClient, HttpParams, HttpEventType, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router'
import { environment as configs } from 'src/environments/environment';
import { CommonService } from "../common.service"
import { NzModalService } from 'ng-zorro-antd';

declare var Swal;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginfrm: FormGroup
  isShow=true;
  formsubmitted = false;
  host = configs['ApiHost'];
  assestBase = configs['Assetbase'];
 csclink=configs['cscCallback'];
  cscstglink=configs['cscstgCallback'];
  cscClientId=configs['cscClientId'];
 cscstgClientId=configs['cscstgClientId'];
  constructor(private fb: FormBuilder, private httpClient: HttpClient, private router: Router, private CSF: CommonService, private modalService: NzModalService) {
    this.CSF.setBusyStatus(false)
    this.CSF.setNavs(false);
  }
  ngOnInit() {
  //window.location.href='https://pblabour.gov.in/';
    console.log("asdf")
    this.CSF.setBusyStatus(false)
    this.CSF.setNavs(false);
    // console.log(this.CSF.isLoading(), 'loading')
    if (localStorage['user'] && localStorage['auth-token']) {
     let user=JSON.parse(localStorage.getItem('user'))
       if(user['role'].toString()=='1003'){
            this.router.navigate(['/worker/dashboard'])
          }else{
            this.router.navigate(['/worker/search-worker'])
          }
      //this.router.navigate(['inspector/dashboard']);
    }
    this.loginfrm = this.fb.group({
      username: [null, [Validators.required]],
      pass: [null, [Validators.required]]
    });
  }

  goschemeforms(){
    this.router.navigate(['/worker/cscintegration'])
  }
  
  loginFun = () => {
    // console.log("loginFun", this.loginfrm.value)
    if (this.loginfrm.valid) {
      this.CSF.toggleBusy();
      this.httpClient.post(this.host + '/login', this.loginfrm.value, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).subscribe(resp => {
        this.CSF.toggleBusy();
        if (resp['status'] == true) {
          localStorage.setItem('sid', resp['sid']);
          let user = {
            'role': resp['role'],
            'username': resp['username'],
            'branch': resp['branch'],
            'usPageSerialCode':resp['usPageSerialCode']
          }
          if (resp['ELRole']) {
            user['ELRole'] = resp['ELRole'];
          }if(resp['role']==1003){
            user['ELRole'] =1003;
          }
          localStorage.setItem('auth-token', resp['token']);
          localStorage.setItem('user', JSON.stringify(user));
         // alert(user['role'].toString()=='1003')
         if(user['role'].toString()=='1050'){
          
          this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:37}})
        }
          else if(user['role'].toString()=='1003'){
            this.router.navigate(['/worker/dashboard'])
          }else{
             this.router.navigate(['/inspector/dashboard'])
          }

        } else {
          Swal.fire({
            type: 'error',
            title: 'Something Went wrong.',
            text: resp["msg"]
          })
        }
      });
    } else {
      Swal.fire({
        type: 'error',
        title: 'Wrong Cridentials',
        text: 'Please Enter Valid Username & Password',
      })
    }
  }
}
